import React from "react";

import { ServiceAccount } from "../../application/domain/service-account/service-account";
import { reportUnexpectedError } from "../../error-reporter";
import { gqlClient, gqlHeader, runGqlQueryV2 } from "../../graphql/client";

export const useServiceAccountsListPage = (tenantId: string) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [serviceAccounts, setServiceAccounts] = React.useState<
    ServiceAccount[]
  >([]);

  React.useEffect(() => {
    setIsLoading(true);
    const fetchServiceAccounts = async () => {
      const res = await runGqlQueryV2(() => {
        return gqlClient.serviceAccounts({ tenantId }, gqlHeader("q"));
      });

      if (res.error) {
        reportUnexpectedError(res.error.rawError);
        alert("サービスアカウントの取得に失敗しました");
        return;
      }

      setServiceAccounts(res.data!.serviceAccounts);
      setIsLoading(false);
    };
    fetchServiceAccounts();
  }, [tenantId, setIsLoading, setServiceAccounts]);

  return {
    isLoading,
    serviceAccounts,
  };
};
